import React from 'react';
import DirectorItem from '../../about-us/DirectorItem/DirectorItem';
import { SliderContainer } from '../../common';

const sliderOptions = {
  slidesToShow: 3,
  infinite: true,
  responsive: [
    {
      breakpoint: 1400,
      settings: {
        arrows: false,
      },
    },
    {
      breakpoint: 960,
      settings: {
        arrows: false,
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 640,
      settings: {
        arrows: false,
        slidesToShow: 1,
      },
    },
  ],
};
const BoardOfDirectors = ({ data }) => {
  const renderDirectorItem = (item, key) => (
    <DirectorItem
      item={item}
      key={key}
      itemScope
      itemType='https://schema.org/Person'
    />
  );
  return (
    <SliderContainer
      title={data?.title}
      icon={data?.icon}
      options={sliderOptions}
      addClass={data.directors}
      itemScope
      itemType='https://schema.org/Organization'
    >
      {data?.directors.map(renderDirectorItem)}
    </SliderContainer>
  );
};

export default BoardOfDirectors;
